<div class="container" [ngClass]="{'detail-page': isClinicianUser}">
  <div class="row">
    <div class="col-md-12 patient-search">
      <div class="row">
        <div class="col-md-6">
          <label>{{this.detailPageSearchHeader}}</label>
          <div class="input-group mb-2 tertiary-search w-100">
            <div class="has-clear w-100">
              <input type="text" name="search" [(ngModel)]="searchPatientDeviceValue" class="form-control"
                     placeholder="{{clinicalSearchPlaceholder}}" id="searchPatientDevice" ngxBarCodePut
                     [debounce]="100" autocomplete="off" (onDetected)="onDetected($event)" (onDelete)="onDelete($event)"
                     (keypress)="onKeypressEvent($event)" appautofocus>

              <button *ngIf="isResetButtonEnabled" class="clear-data" type="reset" (click)="resetSearchText();">
                <i class="icon-close-bold-sm"></i>
              </button>
            </div>
            <span class="input-group-append">
              <a class="ui-link serachIcon" (click)="searchPatientDevice();">
                <div class="input-group-text btn-tertiary-search border-0"><i class="icon-search-bold"></i></div>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Patient Device Details-->
  <div class="row mt-4">
    <div class="col-md-4">
      <h3 class="mb-4 detail-font-weight">{{resourceKeyValue.patientInformationTitle}}</h3>
      <div *ngIf="this.patientDeviceData.patientRecord == null" class="d-flex flex-column w-50">
        <div class="justify-content-center d-flex">
          <div class=" border rounded p-2 text-center mr-3">
            <i class="icon-user-profile-bold f-50 text-gray"></i>
          </div>
        </div>
        <div class="text-center mt-3 text-gray no-patient-data">
          {{resourceKeyValue.noPatientAssociated}}
        </div>
      </div>
      <div *ngIf="this.patientDeviceData.patientRecord != null">
        <h4 class="font-weight-bold">{{this.patientDeviceData.patientRecord.lastName}}, {{this.patientDeviceData.patientRecord.firstName}} {{this.patientDeviceData.patientRecord.middleName}} </h4>
        <div class="media">
          <span class="border rounded p-2 text-center mr-3">
            <i class="icon-user-profile-bold f-50"></i>
          </span>
          <div class="media-body">
            <ul class="list-unstyled">
              <li><strong>{{this.patientDeviceData.patientRecord.patientIdentifier | uppercase }}:</strong> {{this.patientDeviceData.patientRecord.patientId}}</li>
              <li><strong>{{resourceKeyValue.dobTitle}}:</strong> {{this.patientDeviceData.patientRecord.dob | date: "ddMMM yyyy" }}</li>
              <li><strong>{{resourceKeyValue.locationTitle}}:</strong> {{this.patientDeviceData.patientRecord.location}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <h3 class="mb-4 detail-font-weight">{{resourceKeyValue.deviceInformationTitle}}</h3>
      <div class="table-responsive">
        <table class="table device-table">
          <thead>
            <tr>
              <th [width]="50" scope="col">{{resourceKeyValue.deviceIdTitle}}</th>
              <th [width]="30" scope="col">{{resourceKeyValue.deviceTypeTitle}}</th>
              <th [width]="20" scope="col">
                <a *ngIf="this.patientDeviceData.patientRecord != null && this.patientDeviceData.deviceCatalog != null"
                   href="javascript:void(0);" class="disassociate-link"
                   (click)="disassociateConfirmationPopup(this.patientDeviceData.patientRecord.id, searchPageEnum.Patient,'','All')">
                  {{resourceKeyValue.disassociateAllTitle}}
                </a>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="this.patientDeviceData.deviceCatalog != null">
            <tr *ngFor="let device of patientDeviceData.deviceCatalog" id="{{device.id}}">
              <td scope="row">{{device.deviceIdentifier}}</td>
              <td scope="row">{{device.deviceTypeName}}</td>
              <td scope="row">
                <button *ngIf="this.patientDeviceData.patientRecord != null" _ngcontent-ddb-c64="" aria-label="Close" type="button" class="close tabfocusable"
                        (click)="disassociateConfirmationPopup(device.associationId, searchPageEnum.Patient, device.deviceIdentifier, 'Single');">
                  <i _ngcontent-ddb-c64="" class="icon-close-bold-sm"></i>
                </button>
                <button *ngIf="this.patientDeviceData.patientRecord == null" _ngcontent-ddb-c64="" aria-label="Close" type="button" class="close tabfocusable"
                        (click)="disassociateConfirmationPopup(device.id, searchPageEnum.Device, null, 'Single')">
                  <i _ngcontent-ddb-c64="" class="icon-close-bold-sm"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="this.patientDeviceData.deviceCatalog == null || this.patientDeviceData.deviceCatalog.length == 0">
            <tr><td class="text-center" colspan="3">{{resourceKeyValue.noDevicesAssociated}}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Validation error modal -->
  <ng-template #clinicalcontent let-c="close" let-d="dismiss">
    <div class="error-left">
      <i class="icon-alert-bold"></i> {{resourceKeyValue.clinicianModalTitle}}
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p>{{modalBodyMessage}}</p>
          <p>{{modalBodyMessage1}}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer modal-footer-btns">
      <button type="button" class="btn btn-primary ml-4" (click)="closeManualModal();">{{resourceKeyValue.ok}}</button>
    </div>
  </ng-template>

 <!--Manual Entry form modal-->
<ng-template #manualEntryContent let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="manualBarcodePopup">{{resourceKeyValue.clinicianModalBarCodePopupTitle}}</h3>
    <button type="button" tabindex="0" class="close tabfocusable" (click)="closeManualModal();" aria-label="Close">
      <i id="" class="icon-close-bold-sm"></i>
    </button>
  </div>
  <form [formGroup]="manualEntryForm" (ngSubmit)="submitManualEntryForm()">
  <div class="modal-body">  
      <div class="form-check pt-3" *ngFor="let manualEntry of manualEntryReasonList">
        <input class="form-check-input" type="radio"
               value="{{manualEntry.value}}"
               formControlName="manualEntryReason"
               id="{{manualEntry.label}}"
               (change)="changeManualReason(manualEntry); ">

        <label class="form-check-label" for="{{manualEntry.label}}">{{manualEntry.label}}</label>
      </div>

      <div class="form-group pt-2">
        <textarea *ngIf="isCommentsBoxEnabled" rows="3" placeholder="Enter comments"
                  class="form-control" maxlength="250"
                  (keyup)="onCommentsKeyup(this.otherComments)"
                  [(ngModel)]="otherComments"
                  [ngClass]="{'is-invalid': this.otherComments == ''}"
                  formControlName="othercomments" aria-multiline="true"
                  aria-describedby="textarea">
        </textarea>
      </div>  
  </div>
  <div class="modal-footer modal-footer-btns">
    <button type="button" class="btn btn-secondary" (click)="closeManualModal()">{{resourceKeyValue.cancel}}</button>
    <button type="submit" class="btn btn-primary ml-4" [disabled]="isManualOkButtonDisabled">
      {{resourceKeyValue.ok}}
    </button>
  </div>
</form>
</ng-template>

  <!-- Disassociate error modal -->
  <ng-template #disassociateContent let-c="close" let-d="dismiss">
    <div class="error-left">
      <i class="icon-alert-bold"></i> {{this.disassociateModalTitle}}
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p>{{modalMessage}}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" tabindex="-1" class="btn btn-secondary" (click)="closeModal();">{{resourceKeyValue.cancel}}</button>
      <button type="button" class="btn btn-primary ml-4" (click)="disassociateDevices();">{{resourceKeyValue.ok}}</button>
    </div>
  </ng-template>

  <!--Change/Keep association modal-->
  <ng-template #changeKeepAssociationContent let-modal>
    <div class="modal-header">
      <h3 class="modal-title" id="changeAssociationPopup">{{resourceKeyValue.changeAssociation}}</h3>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p>{{modalBodyMessage}}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" tabindex="-1" class="btn btn-secondary" (click)="closeModal();">{{resourceKeyValue.keepAssociation}}</button>
      <button type="button" class="btn btn-primary ml-4" (click)="changeAssociation();">{{resourceKeyValue.changeAssociation}}</button>
    </div>
  </ng-template>

  <!--Patient Therapy modal-->
  <ng-template #patientTherapyContent let-modal>
    <div class="modal-header">
      <h3 class="modal-title" id="patientTherapyModal">{{resourceKeyValue.patientTherapyTitle}}</h3>
    </div>
    <form [formGroup]="patientTherapyForm" (ngSubmit)="submitPatientTherapyForm()">
      <div class="modal-body">
        <div class="form-check pt-3">
          <input class="form-check-input" id="newTherapySession" value="{{patientTherapy.NewTherapySession}}" type="radio" formControlName="patientTherapyName" />
          <label class="form-check-label" for="newTherapySession">{{resourceKeyValue.newTherapySessionText}}</label>
        </div>
        <div class="form-check pt-3">
          <input class="form-check-input" id="continuationTherapy" value="{{patientTherapy.ContinuationOfTherapy}}" type="radio" formControlName="patientTherapyName" />
          <label class="form-check-label" for="continuationTherapy">{{resourceKeyValue.continuationofTherapyText}}</label>
        </div>
      </div>
      <div class="modal-footer modal-footer-btns">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">{{resourceKeyValue.cancel}}</button>
        <button type="submit" class="btn btn-primary ml-4" [disabled]="!patientTherapyForm.valid">
          {{this.resourceKeyValue.ok}}
        </button>
      </div>
    </form>
  </ng-template>

   <!--Device creation modal-->
   <ng-template #deviceCreationModal let-modal>
    <div class="modal-header">
      <h3 class="modal-title" id="deviceCreationPopup">{{resourceKeyValue.clinicianDeviceCreationPopup}}</h3>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p>{{modalBodyMessage}}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" tabindex="-1" class="btn btn-secondary" (click)="closeModal();">{{resourceKeyValue.cancel}}</button>
      <button type="button" class="btn btn-primary ml-4" (click)="createDevice();">{{resourceKeyValue.ok}}</button>
    </div>
  </ng-template>
</div>
<div class="position-fixed fixed-bottom">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-right">
        <button id="" class="btn btn-primary mb-2" routerLink="/clinician" tabindex="0">Next Patient</button>
      </div>
    </div>
  </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>
